import type { RequestParams } from '@/shared/api';
import type { PartnerItemListParams, PartnerProductIndexParams } from '../model/types';

export const PARTNER_KEYS = {
  all: ['partner'] as const,
  list: (params?: RequestParams) => [...PARTNER_KEYS.all, 'list', params] as const,
  detail: (id: number) => [...PARTNER_KEYS.all, 'detail', id] as const,
  itemList: (params?: PartnerItemListParams) => [...PARTNER_KEYS.all, 'item-list', params] as const,
  products: (partnerId: number) => [...PARTNER_KEYS.all, 'products', partnerId] as const,
  productIndexAll: ['partner', 'product-index'] as const,
  productIndex: (params?: PartnerProductIndexParams) => [...PARTNER_KEYS.productIndexAll, params] as const,
};
